export default "__VITE_ASSET__D6qzeRuK__"